import type { MouseEvent } from "react";

import type { ITooltipProps } from "@similarweb/ui-components";
import { Tooltip } from "@similarweb/ui-components";

import * as SC from "./styles";

type ApplyButtonSchema = {
    onClick: (e: MouseEvent<HTMLDivElement>) => void;
    text: string;
    tooltipProps?: ITooltipProps;
    dataAutomation?: string;
};

export const ApplyButton = ({ onClick, text, tooltipProps, dataAutomation }: ApplyButtonSchema) => (
    <SC.ApplyButton
        onClick={onClick}
        data-automation={dataAutomation}
    >
        <Tooltip
            enabled={!!tooltipProps}
            {...tooltipProps}
        >
            <SC.Text>{text}</SC.Text>
        </Tooltip>
    </SC.ApplyButton>
);
